import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { Box, Button, Typography } from '@mui/material';
import strings from 'common/Translation/Translate';
import { useEffect } from 'react';
import axiosInstance from 'utils/axios';
import { identifiers } from 'utils/constants/identifiers';
import { images } from 'utils/constants/images';
import { routes } from 'utils/constants/routes';
import { URLS } from 'utils/constants/urls';
import { useCustomNavigate } from 'utils/hooks/useCustomNavigate';
import { fetchFromStorage } from 'utils/storage';

const ErrorPage = () => {
  const navigate = useCustomNavigate();
  const org = fetchFromStorage(identifiers.organization) as any;

  useEffect(() => {
    (async () => {
      if (org !== '*') {
        const { status } = await axiosInstance.get(URLS.userProfile);
        if (status === 200) {
          navigate('/');
        }
      }
    })();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'primary',
        // background: theme.palette.primary.main,
        // color: theme.palette.primary.contrastText,
        flexDirection: 'column',
      }}>
      <img width="50%" src={images.serverDown} alt="page not found" />
      <Typography fontSize={{ xs: 20, md: 40 }}>{strings.error_page_service_unavailable_text}</Typography>
      {org === '*' ? (
        <Button
          data-testid="button"
          sx={{
            mt: 2,
            background: '#013556',
            fontWeight: 'bold',
            color: '#fff',
            '&:hover': { background: '#013556', color: '#fff', opacity: 0.9 },
          }}
          variant="contained"
          onClick={() => navigate(routes.addOrganization)}>
          {strings.error_page_back_to_add_organization_text}
        </Button>
      ) : (
        <>
          <Typography textAlign="center" fontSize={{ xs: 12, md: 16 }} my={2}>
            {strings.error_page_desc_text}
          </Typography>
          <Button
            data-testid="button"
            sx={{
              mt: 2,
              background: '#013556',
              fontWeight: 'bold',
              color: '#fff',
              '&:hover': { background: '#013556', color: '#fff', opacity: 0.9 },
            }}
            variant="contained"
            onClick={() => navigate('/')}>
            <HomeRoundedIcon sx={{ mr: 1 }} />
            {strings.error_page_back_home_text}
          </Button>
        </>
      )}
    </Box>
  );
};

export default ErrorPage;
